import CardModal, { CardModalProps } from '@anm/components/modals/CardModal';
import { FC } from 'react';
import styled from 'styled-components';

import useListenEvents from './useListenEvents';

const Iframe = styled.iframe`
  width: 1280px;
  height: 760px;
  border: none;
  max-width: 80vw;
  max-height: 80vh;
  position: relative;
`;

type TRecorderModal = CardModalProps & {
  waveUrl: string;
};

const RecorderModal: FC<TRecorderModal> = ({ waveUrl, onModalClose }) => {
  useListenEvents(waveUrl); // TODO rollback onModalClose after test blobUrl in editor
  const recorderUrl = `${waveUrl}video-record/`;

  return (
    <CardModal onModalClose={onModalClose} isClickableBackdrop={false}>
      <Iframe allow="camera; microphone; display-capture; autoplay; clipboard-write;" src={recorderUrl} />
    </CardModal>
  );
};

export default RecorderModal;
